import React, { useEffect, useState } from 'react'
import { Dropdown } from '@entur/dropdown'
import { VariantType } from '@entur/form'
import { getProducts } from '../../api-clients/eba-clients'
import { useApiOnLoad } from '../../api-clients/client-hooks'
import { FetchState, Category, Company } from '../../api-clients/api-types'
import { ValidationFormField } from '../../utils/form-utils'

const capitalize = (s?: string): string | undefined => (s ? s.charAt(0).toUpperCase() + s.slice(1) : undefined)

export const categoryFormField = (value?: Category, required = false): ValidationFormField<string> => {
  return {
    value: value?.id || '',
    displayValue: capitalize(value?.name) || 'Ikke valgt',
    variant: '',
    feedback: '',
    fieldName: 'preferredProductId',
    displayName: 'Kategori',
    validation: {
      required,
    },
  }
}

type DropdownItemType = {
  value: string | undefined
  label: string
}

const categoryToDropdownItemType = (category: Category) => {
  return { label: capitalize(category.name) || '', value: category.id }
}

type CategoryDropdownProps = {
  category: ValidationFormField<string>
  company: Company
  update: (value: ValidationFormField<string>) => void
}
const CategoryDropdown: React.FC<CategoryDropdownProps> = (props) => {
  const [variant, setVariant] = useState(props.category.variant)
  const [feedback, setFeedback] = useState(props.category.feedback)
  const selectedItem =
    props.category.value !== ''
      ? {
          label: props.category.displayValue || '',
          value: props.category.value,
        }
      : null
  const [response] = useApiOnLoad<Array<Category>>(getProducts, {
    id: props.company.companyId.toString() || '',
  })

  useEffect(() => {
    if (response.status === FetchState.SUCCESS) {
      const validCategory = response.data.find((product) => product.id === props.category.value)
      if (!validCategory && props.category.displayValue !== 'Ikke valgt') {
        setVariant('info')
        setFeedback(`${props.category.displayValue} er ikke tilgjengelig for ${props.company.name}`)
      }
    }
  }, [response, props])

  const products =
    response.status === FetchState.SUCCESS
      ? () => response.data.flatMap<DropdownItemType>(categoryToDropdownItemType)
      : [{ label: props.category.displayValue || '', value: props.category.value }]

  return (
    <Dropdown<string | undefined>
      style={{ cursor: 'pointer' }}
      label={props.category.displayName}
      variant={variant as VariantType}
      feedback={feedback}
      items={products}
      selectedItem={selectedItem}
      onChange={(e) => {
        if (e) {
          props.update({ ...props.category, value: e.value || '', displayValue: e.label })
        }
      }}
    />
  )
}

export default CategoryDropdown
